import { ModalType } from '@wix/da-shared-react/pkg/Modals/redux/types';
import MiniMuroModal from './modals/MiniMuroModal';
import MobileMuroModal from './modals/MobileMuroModal';

export const muroModalRenderer = (
  modalType: string,
  requestClose: () => void,
  params?: any
) => {
  switch (modalType) {
    case ModalType.MINI_MURO:
      return <MiniMuroModal requestClose={requestClose} {...params} />;
    case ModalType.MINI_MOBILE_MURO:
      return (
        <MobileMuroModal
          requestClose={requestClose}
          {...params}
          isFull={true}
        />
      );
    case ModalType.MOBILE_MURO:
      return (
        <MobileMuroModal
          requestClose={requestClose}
          {...params}
          isFull={false}
        />
      );
    default:
      return null;
  }
};

export default muroModalRenderer;
